import component from './it-IT/component';
import globalHeader from './it-IT/globalHeader';
import menu from './it-IT/menu';
import pages from './it-IT/pages';
import pwa from './it-IT/pwa';
import settingDrawer from './it-IT/settingDrawer';
import settings from './it-IT/settings';
import fixOverlay from './it-IT/fix_overlay';
import fixOpenapi from './it-IT/fix_openapi';
import fixAdminMisc from './it-IT/fix_adminmisc';
import fixBilling from './it-IT/fix_billing';
import fixComponents from './it-IT/fix_components';
import fixConsoleMisc from './it-IT/fix_consolemisc';
import fixGap from './it-IT/fix_gap';
import fixSystemconfig from './it-IT/fix_systemconfig';
import fixTenant from './it-IT/fix_tenant';
import fixVoiceClone from './it-IT/fix_voiceclone';
import fixTodo from './it-IT/fix_todo';


export default {
  'navBar.lang': 'Lingua',
  'layout.user.link.help': 'Aiuto',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Termini',
  'app.preview.down.block': 'Scarica questa pagina nel progetto locale',
  'app.welcome.link.fetch-blocks': 'Ottieni tutti i blocchi',
  'app.welcome.link.block-list': 'Costruisci rapidamente pagine standard basate sul framework di sviluppo dei blocchi',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
